import { clsx } from "clsx"

export function cn(...inputs) {
  return clsx(inputs)
}

export function getCsrfToken() {
  return (
    document.querySelector('meta[name="csrf-token"]')?.content || ""
  )
}
